module.exports = __webpack_public_path__ + "media/images/paper-plane-cfde6310a8f534128cf6dd31ba7ed6b4.png";